var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActiveSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.48242,
    y: 4.82825,
    width: 13.0344,
    height: 9,
    rx: 2,
    stroke: "#C1C7D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.3213H16.25",
    stroke: "#C1C7D4",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.6718H12.5",
    stroke: "#C1C7D4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.6718V14.1718",
    stroke: "#C1C7D4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActiveSessions);
export default __webpack_public_path__ + "static/media/profile-active-sessions.0ad7bd14fff9d3121b58ad55d46fe880.svg";
export { ForwardRef as ReactComponent };